<template>
	<div>
		<v-row no-gutters>
			<template v-if="edit">
				<v-textarea
					filled
					class="text-body-2 mr-1"
					:placeholder="$gettext('Notes') + ' PT'"
					v-model="result.note_pt"
					auto-grow
				></v-textarea>
				<v-textarea
					filled
					class="text-body-2 mr-1"
					:placeholder="$gettext('Notes') + ' EN'"
					v-model="result.note_en"
					auto-grow
				></v-textarea>
				<v-textarea
					filled
					class="text-body-2"
					:placeholder="$gettext('Notes') + ' ES'"
					v-model="result.note_es"
					auto-grow
				></v-textarea>
			</template>
			<v-col cols="12" v-else>
				<p>{{result.note_pt}}</p>
				<p>{{result.note_en}}</p>
				<p>{{result.note_es}}</p>
			</v-col>
		</v-row>
		<v-row no-gutters>
			<span class="text-subtitle-1 mr-2">Pontos - Tipos</span>
			<v-btn v-if="edit" x-small fab class="mb-3" color="primary" @click="showNewPair = !showNewPair">
				<v-icon small>mdi-plus</v-icon>
			</v-btn>
		</v-row>
		<v-form v-if="edit" ref="form">
			<v-row v-if="showNewPair" no-gutters align="center" class="mb-3">
				<v-select
					v-model="newPair.point"
					:items="points"
					item-text="name"
					item-value="id"
					:label="$gettext('Point')"
					outlined
					color="primary"
					hide-details
					class="pr-1"
					return-object
					:rules="[required]"
				></v-select>
				<v-select
					v-model="newPair.type"
					:items="types"
					item-text="name"
					item-value="id"
					label="Tipo"
					outlined
					color="primary"
					hide-details
					class="pr-1"
					return-object
					:rules="[required]"
				></v-select>
				<v-btn color="primary darken-1" @click="createPair">
					<translate>Add</translate>
				</v-btn>
			</v-row>
		</v-form>
		<v-row no-gutters class="mb-4">
			<p v-if="result.point_types.length == 0" class="font-weight-thin ml-2 text-body-2 grey--text">Sem canais.</p>
			<v-chip v-else :close="edit" @click:close="removePair(pointType)" v-for="(pointType, i) in result.point_types" :key="i" class="mr-1">
				{{ pointType.point.name }} - {{ pointType.type.name }}
			</v-chip>
		</v-row>
		<v-row no-gutters>
			<span class="text-subtitle-1 mr-2">ICDs</span>
			<v-btn
				x-small
				fab
				class="mb-3"
				color="primary"
				@click="showNewICD = !showNewICD"
				v-if="edit"
			>
				<v-icon small>mdi-plus</v-icon>
			</v-btn>
		</v-row>
		<v-row v-if="showNewICD" no-gutters>
			<v-col cols="12">
				<SearchICD :selectedICD="result.icds" context="new-product" />
			</v-col>
		</v-row>
		<v-row no-gutters class="mb-4">
			<p v-if="result.icds.length == 0" class="font-weight-thin ml-2 text-body-2 grey--text">Sem icds.</p>
			<v-chip v-else v-for="icd in result.icds" :key="icd.disease_id" :close="edit" @click:close="removeICD(icd)" class="mr-1">
				{{ icd.code }} - {{ icd.title }}
			</v-chip>
		</v-row>
		<v-row no-gutters>
			<span class="text-subtitle-1 mr-2">Pontos</span>
			<v-btn
				x-small
				fab
				class="mb-3"
				color="primary"
				@click="showNewPoint = !showNewPoint"
				v-if="edit"
			>
				<v-icon small>mdi-plus</v-icon>
			</v-btn>
		</v-row>
		<v-row v-if="showNewPoint" no-gutters>
			<v-col cols="12">
				<SearchPoints @add-point="addPoint" :auricular="false" />
			</v-col>
			<v-col cols="12">
				<AcuPointList :list="result.points" @remove-point="removePoint" :grid="false" :edit="true" />
			</v-col>
		</v-row>
		<v-row no-gutters>
			<p v-if="result.points.length == 0" class="font-weight-thin ml-2 text-body-2 grey--text">Sem points.</p>
			<v-chip v-else v-for="point in result.points" :key="point.id" :close="edit" @click:close="removePoint(point)" class="mr-1">
				{{ point.name }} - {{ point.side }}
			</v-chip>
		</v-row>
	</div>
</template>

<script>
import SearchICD from '../../components/icd/SearchICD.vue';
import SearchPoints from "@/components/appointment/treatments/tcm/acupuncture/SearchPoints.vue";
import AcuPointList from "@/components/acupuncture/AcuPointList.vue";

export default {
	name: "PulseResultForm",
  props: ["result", "edit", "points", "types"],
  components: {
    SearchICD,
		SearchPoints,
		AcuPointList
  },
	data: () => ({
    newPair: {
      point: null,
      type: null
    },
    showNewPair: false,
    showNewICD: false,
		showNewPoint: false
  }),
	computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    createPair() {
			if(this.$refs.form.validate()) {
				let pair = {};
				pair.point = this.newPair.point;
				pair.type = this.newPair.type;
				this.result.point_types.push(pair);
				this.newPair.point = null;
				this.newPair.type = null;
				this.$refs.form.reset()
			}
    },
    removePair(pair) {
      this.result.point_types.splice(this.result.point_types.indexOf(pair), 1);
    },
		removeICD(icd) {
			this.result.icds.splice(this.result.icds.indexOf(icd), 1);
		},
		reset() {
			this.showNewPair = false;
			this.showNewICD = false;
			this.showNewPoint = false;
		},
		addPoint(point) {
			this.result.points.push(point);
		},
		removePoint(point) {
			this.result.points.splice(this.result.points.indexOf(point), 1);
		}
  }
};
</script>